import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { cacheAdd } from './cache-actions';

/**
 * HOC components for "caching" data into the the redux store
 */
const CacheWrapper = (Component) => (props) => {
	return (
		<Component {...props} />
	);
}

 const mapDispatchToProps = dispatch => {
 	return {
 		cacheAdd: (key, data) =>  dispatch(cacheAdd(key, data))
 	};
 };

 const mapStateToProps = (state, ownProps) => {
 	return {
 		cacheValue: state.itemCache[ownProps.cacheKey]
 	};
 };

 export const withCacheAdd  = compose(connect(null, mapDispatchToProps),CacheWrapper);
 export const withCacheRead = compose(connect(mapStateToProps, null),CacheWrapper);